import {_utils, viewportChecker} from "../utils/_utils.js";
import {_state} from "../state/state.js";

export const header = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('#header', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (header) => {
    // headerVariant(header);
    burgerMenu(header);
    mobileMenuDropdown();
    checkeSubMenuPosition(header);
    headerDesktopSubMenu(header);
    // mobileMenuLinks();
}

const burgerMenu = (header) => {
    const burgerBtn = header.querySelector('.header__burger');
    const mobileBurger = document.querySelector('.mobile-menu__close');
    const burgerMenu = document.querySelector('#header-mobile-menu');
    if(burgerBtn){
        const toggleBurgerMenu = () => {
            if(_state.isActiveBurgerMenu){
                document.documentElement.classList.add("overflow-hidden");
                document.body.classList.add("overflow-hidden");
                burgerBtn.classList.add('active');
                burgerMenu.classList.add('open');
                header.classList.add('menu-opened');
            } else {
                burgerBtn.classList.remove('active');
                burgerMenu.classList.remove('open');
                header.classList.remove('menu-opened');
                document.documentElement.classList.remove("overflow-hidden");
                document.body.classList.remove("overflow-hidden");
            }
        }

        window.addEventListener('isActiveBurgerMenuChanged', () => {
            toggleBurgerMenu();
        })

        _state.updateState({isActiveBurgerMenu: burgerBtn.classList.contains('active') && !window.matchMedia('(min-width: 1200px)').matches});
        toggleBurgerMenu();
        burgerBtn.addEventListener('click', e => {
            e.preventDefault();
            _state.updateState({isActiveBurgerMenu: !_state.isActiveBurgerMenu && !window.matchMedia('(min-width: 1200px)').matches});
        })
        mobileBurger.addEventListener('click', e => {
            e.preventDefault();
            _state.updateState({isActiveBurgerMenu: !_state.isActiveBurgerMenu && !window.matchMedia('(min-width: 1200px)').matches});
        })

        _utils.rebuildComponentsOnResize(() => {
            if(viewportChecker.mobDesk() && _state.isUserActive){
                _state.updateState({isActiveBurgerMenu: false});
            }
        });
    }
}

const checkeSubMenuPosition = (header)=> {
    function fixMenuOverflow() {
        header.querySelectorAll('.header__menu-sub-menu').forEach(submenu => {
            const rect = submenu.getBoundingClientRect();
            const isOutRight = rect.right > window.innerWidth;

            if (isOutRight) {
                submenu.style.right = '0';
                submenu.style.left = 'auto';
            } else {
                submenu.style.right = '';
                submenu.style.left = '';
            }
        });
    }

    window.addEventListener('resize', fixMenuOverflow);

    fixMenuOverflow();
}

const mobileMenuDropdown = ()=> {
    const mobileMenu = document.querySelector('.mobile-menu');
    const linksDropdown = mobileMenu.querySelectorAll('.mobile-menu__nav li.has-sub-menu')
    const mobileSubMenu = mobileMenu.querySelector('.mobile-menu__nav-submenu')
    const mobileSubMenuBackBtns = mobileSubMenu.querySelectorAll('.mobile-menu__nav-submenu-back-btn')

    linksDropdown?.forEach(link=> {
        link.addEventListener('click',(e)=> {
            e.preventDefault();
            const dataKeyId = link.getAttribute('data-key');
            const dataKeyIdTarget = mobileSubMenu.querySelector('#'+dataKeyId);
            mobileSubMenu.classList.add('open');
            mobileMenu?.classList.add('sub-menu-opened');
            dataKeyIdTarget?.classList.add('active');
        })
    })

    mobileSubMenuBackBtns?.forEach(backBtn=> {
        backBtn?.addEventListener('click',(e)=> {
            mobileSubMenu.classList.remove('open');
            mobileMenu?.classList.remove('sub-menu-opened');
            mobileSubMenu.querySelectorAll('.mobile-menu__nav-submenu-item')?.forEach(li=> {
                li.classList.remove('active')
            })
        })
    })

}

// const mobileMenuLinks = ()=> {
//     const mobileMenu = document.querySelector('.mobile-menu');
//     const links = mobileMenu.querySelectorAll('a')
//
//     links?.forEach(link=> {
//         link.addEventListener('click',(e)=> {
//             _state.updateState({isActiveBurgerMenu: false});
//         })
//     })
// }

const headerDesktopSubMenu = (header)=> {
    const menuItems = header.querySelectorAll('.header__menu li.has-sub-menu')
    const headerSubMenu = document.querySelector('.header__sub-menu')
    const headerSubMenuItems = headerSubMenu.querySelectorAll('.header__sub-menu .header__sub-menu-item')

    menuItems?.forEach(item=> {
        const itemDataKey = item.getAttribute('data-key');
        console.log(itemDataKey);
        item.addEventListener('click',(e)=> {
            e.preventDefault();
            headerSubMenuItems?.forEach(itemSubMenu=> {
                if (itemDataKey === itemSubMenu.getAttribute('data-key')) {
                    itemSubMenu?.classList.add('active')
                }
            })
            item?.classList.add('active')
            headerSubMenu?.classList.add('open')
            document.documentElement.classList.add("overflow-hidden");
            document.body.classList.add("overflow-hidden");
        })
    })

    //close menu

    window.addEventListener('click',(e)=> {
        if (e.target.classList.contains('header__sub-menu') || e.target.classList.contains('header__sub-menu-close')) {
            headerSubMenu?.classList.remove('open')
            menuItems?.forEach(item=> {
                item.classList.remove('active')
            })
            headerSubMenuItems?.forEach(item=> {
                item.classList.remove('active')
            })
            document.documentElement.classList.remove("overflow-hidden");
            document.body.classList.remove("overflow-hidden");
        }
    })
}

const headerVariant = (header)=> {
    window.addEventListener('scroll',()=> {
        if (!header.classList.contains('header-color-lock')) {
            if (window.scrollY > 1) {
                header.classList.add('header-color');
            } else {
                header.classList.remove('header-color');
            }
        }
    })
}


